import { Breakpoints, styled } from "@vw-marketing/us-components";

import { VWTheme } from "../../../../shared/typings/vw-theme";

export const StyledDividerContainer: any = styled.div`
  width: 100%;
`;

export const StyledDealerCardContainer: any = styled.div`
  ${({ theme, hasError }: { theme: VWTheme, hasError: boolean }) => {
    const paddingTopBottomValue = hasError ? theme.size.static400 : theme.size.static250;
    const paddingLeftRightValue = hasError ? theme.size.static350 : theme.size.static350;

    return `
      align-items: ${hasError ? "center" : "flex-start"};
      background-color: ${theme.colors.background.primary};
      border-radius: 12px;
      border: 1px solid ${theme.colors.border.default};
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static250};
      min-width: 170px;
      padding: ${paddingTopBottomValue} ${paddingLeftRightValue};
      width: 100%;

      @media (min-width: ${Breakpoints.b1600}px) {
        gap: ${theme.size.static300};
      }
    `;
  }}
`;

/*
  Error component
*/
export const StyledErrorContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static150};
      justify-content: center;
      align-items: center;

      p {
        text-align: center;
      }
    `;
  }}
`;

export const StyledErrorTitleContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static300};
      justify-content: center;
      align-items: center;

      svg {
        fill: ${theme.colors.signal.error};
      }
    `;
  }}
`;

/* 
  Top Section Containers
*/
export const StyledTopSectionContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static300};

      @media (min-width: ${Breakpoints.b1600}px) {
        gap: ${theme.size.static350};
      }
    `;
  }}
`;

export const StyledNameAndReviewsContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static100};
      width: 100%;  
    `;
  }}
`;

export const StyledDealerNameContainer: any = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const StyledDealerReviewsContainer: any = styled.div``;

export const StyledCTAsContainer: any = styled.div<{ theme: VWTheme, isMobile: boolean }>`
  ${({ theme, isMobile }) => {
    return `
      align-items: start;
      display: flex;
      flex-wrap: wrap;
      justify-content: ${!isMobile ? "center" : "space-between"};
      width: 100%;

      @media (max-width: 300px) {
        gap: ${theme.size.static300};
      }

      @media (min-width: ${Breakpoints.b960}px) {
        gap: ${theme.size.static510};
      }
    `
  }}
`;
/* 
  End Top Section Containers
*/

/* 
  Middle Section Containers
*/
export const StyledMiddleSectionContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      gap: 16px;
      width: 100%;

      & > *:first-child {
        flex: 1;
      }
      
      & > *:last-child {
        white-space: nowrap;
        flex-shrink: 0;
      }

      @media (max-width: 300px) {
        flex-direction: column-reverse;
        
        & > *:last-child {
          white-space: wrap;
          flex-shrink: 1;
        }
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        gap: ${theme.size.static350};
      }
    `;
  }}
`;
/* 
  Middle Section Containers
*/

/* 
  Bottom Section Containers
*/
export const StyledBottomSectionContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static250};
      width: 100%;

      & > button {
        min-width: 122px; /* Mobile/Tablet */
        
        @media (min-width: ${Breakpoints.b1600}px) {
          min-width: 154px; /* Desktop */
        }
      }

      @media (min-width: ${Breakpoints.b1600}px) {
        gap: ${theme.size.static300};
      }
    `;
  }}
`;

export const StyledScheduleInformation = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: center;
      align-self: stretch;
      display: flex;
      gap: ${theme.size.static150};
    `;
  }}
`;

interface EllipseProps {
  $status?: 'open' | 'closed';
}

export const StyledScheduleTextWrapper = styled.div<EllipseProps>`
  ${({ theme, $status = 'open' }: { theme: VWTheme; $status?: 'open' | 'closed' }) => {
    const colorMap = {
      closed: theme.colors.signal.error,
      open: theme.colors.signal.success,
    };

    return `
      align-items: center;
      display: flex;
      gap: 2px;

      p {
        color: ${colorMap[$status]};
      }
      
      /* Remove default margins from TextCustom */
      & > * {
        margin: 0;
      }
    `;
  }}
`;

export const StyledEllipse = styled.div<EllipseProps>`
  ${({ theme, $status = 'open' }: { theme: VWTheme; $status?: 'open' | 'closed' }) => {
    const colorMap = {
      closed: theme.colors.signal.error,
      open: theme.colors.signal.success,
    };

    return `
      background-color: ${colorMap[$status]};
      border-radius: 50%;
      flex-shrink: 0;
      height: 12px;
      width: 12px;
    `;
  }}
`;
/* 
  End Bottom Section Containers
*/
